import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router/router';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { AlertMessage } from './components/alert-message/alert-message';
import 'animate.css';

function App() {
  return (
    <Provider store={store}>
      <AlertMessage />
      <RouterProvider router={router} />
    </Provider>
  );
}

export default App;
